/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

const FLEX_WRAP_MARGIN = gridSize() * 2;

export const HeaderActions = styled.div({
  marginBottom: `${gridSize() * 2}px`,
});

export const HeaderActionsButtonWrapper = styled.div({
  marginTop: `${FLEX_WRAP_MARGIN}px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
});

export const CreatePRWrapper = styled.div({
  paddingRight: '4px',
});
